import BasePreset from '../base/BasePreset.js'
import fragSrc    from '../../shaders/presets/bloom/fragment.glsl'

export default class BloomPreset extends BasePreset {
    constructor() {
        super()
        this.id   = 'bloom'
        this.name = 'Bloom'
        this.plan = 'free'
        this.defaultObjectColor = '#e87428'
        this.defaultBgColor     = '#0a0005'
    }

    init(canvas) {
        this._setup(canvas, fragSrc)
        const gl = this.gl
        this.uniforms.uObjectColor  = gl.getUniformLocation(this._program, 'uObjectColor')
        this.uniforms.uBgColor      = gl.getUniformLocation(this._program, 'uBgColor')
        this.uniforms.uSphereSize   = gl.getUniformLocation(this._program, 'uSphereSize')
        this.uniforms.uLightAngle   = gl.getUniformLocation(this._program, 'uLightAngle')
    }

    getSchema(plan) {
        if (plan === 'free') return []
        const fields = [
            { key: 'objectColor', type: 'color', label: 'Sphere Color', default: this.defaultObjectColor },
            { key: 'bgColor',     type: 'color', label: 'Background',   default: this.defaultBgColor },
        ]
        return fields
    }

    _applyConfigUniforms() {
        const gl = this.gl
        const [or, og, ob] = this._hexToRgb(this._config.objectColor ?? this.defaultObjectColor)
        gl.uniform3f(this.uniforms.uObjectColor, or, og, ob)
        const [br, bg, bb] = this._hexToRgb(this._config.bgColor ?? this.defaultBgColor)
        gl.uniform3f(this.uniforms.uBgColor, br, bg, bb)
        gl.uniform1f(this.uniforms.uSphereSize, Number(this._config.sphereSize ?? 1.0))
        gl.uniform1f(this.uniforms.uLightAngle, Number(this._config.lightAngle ?? 45))
    }
}
